import {Virtuoso} from 'react-virtuoso'
import {ReactNode} from 'react'
import {IDLE_STEP_FILE_ROW_HEIGHT} from '@features/photos-upload/components/idle-step-file-row'

interface FilesListProps<T extends unknown[]> {
    title: string
    data: T
    dataItem: (index: number, item: T[number]) => ReactNode
}
export const FilesList = <T extends unknown[]>({title, data, dataItem}: FilesListProps<T>) => {
    return (
        <div className="flex flex-col items-stretch gap-4">
            <h2>{title}</h2>
            <Virtuoso
                style={{
                    height: data.length * IDLE_STEP_FILE_ROW_HEIGHT,
                    maxHeight: IDLE_STEP_FILE_ROW_HEIGHT * 5,
                    width: '100%'
                }}
                data={data}
                itemContent={dataItem}
            />
        </div>
    )
}
